module.exports = __webpack_public_path__ + "img/intro-bg.7f0f38f9.png";